import { useMemo } from 'react'
import { DonutLegendItem, DonutChartData } from '../../../../shared/components/DonutCharts'

import { ReactComponent as CircleIcon } from '../../../../assets/images/shapes/circle.svg'
import { ReactComponent as TriangleIcon } from '../../../../assets/images/shapes/triangle-up.svg'
import { ReactComponent as SquareIcon } from '../../../../assets/images/shapes/square.svg'
import { useGetValueMessageSupportQuery } from '../../../../shared/queries/metrics/useGetValueMessageSupportQuery'
import { useGetImpactMetricsQuery } from '../../../../shared/queries/metrics/useGetImpactMetricsQuery'
import { filterEmptyDonutCategories } from '../../../../shared/components/DonutCharts/hooks/filterEmptyCategories'
import { ValueMessage } from '../../../ValueNarrativesView/queries/useGetValueNarrativesQuery'

// @TODO metrics - dynamic legend
const legend: DonutLegendItem[] = [
    { id: 'Supported', label: 'Supported', color: '#56B9A1', icon: CircleIcon },
    { id: 'Supported Suboptimal', label: 'Supported-suboptimal', color: '#F09D3A', icon: TriangleIcon },
    { id: 'Aspirational', label: 'Aspirational', color: '#C93C37', icon: SquareIcon },
]

const useImpactMetrics = () => {
    const getValueMessageSupportQuery = useGetValueMessageSupportQuery()
    const getImpactMetricsQuery = useGetImpactMetricsQuery()

    const data = useMemo((): DonutChartData<ValueMessage>[] => {
        if (!getValueMessageSupportQuery.data) {
            return []
        }

        return getValueMessageSupportQuery.data.map(({ grouping: title, items: statuses }) => {
            const values = legend.map((legendItem) => {
                const items = statuses[legendItem.label] || []
                return { items, count: items.length, label: legendItem.label }
            })
            return { title, values }
        })
    }, [getValueMessageSupportQuery.data])

    const { filteredLegend, filteredData } = useMemo(() => filterEmptyDonutCategories(legend, data), [data])

    const filteredCards = getImpactMetricsQuery.data?.filter((card) => !!card.items.length) || []
    return {
        cards: filteredCards,
        data: filteredData,
        legend: filteredLegend,
        isLoading: getValueMessageSupportQuery.isLoading || getImpactMetricsQuery.isLoading,
    }
}
export default useImpactMetrics
